var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","outlined":""}},[_c('v-row',{staticClass:"px-0 py-1 ma-0",attrs:{"justify":"center","align":"center"}},[_vm._v(" "+_vm._s(_vm.$t('footer_cs_love'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }